export default __webpack_public_path__ + "static/media/file-image_darkGray3.0edeabdf.svg";